import { graphql, readInlineData } from 'react-relay';
import { type getAttributeInfo_itemAttributes$key } from './__generated__/getAttributeInfo_itemAttributes.graphql.ts';
import {
    ITEM_IS_RING_RESIZABLE_ATTRIBUTE_ID,
    ITEM_IS_CUSTOMIZABLE_ATTRIBUTE_ID,
} from '../../constants/itemConstants.ts';

const attributesFragment = graphql`
    fragment getAttributeInfo_itemAttributes on ItemAttributes @inline {
        customizable {
            option {
                serviceId
            }
            text
        }
        ringResizable {
            option {
                serviceId
            }
        }
    }
`;

export const getAttributeInfo = (
    attributesRef: getAttributeInfo_itemAttributes$key | null | undefined
): {
    customizationOptions: string | null | undefined;
    isResizable: boolean;
} => {
    const attributes = readInlineData(attributesFragment, attributesRef ?? null);
    const customizableAttrs = attributes?.customizable || [];
    const regularCustomizable = customizableAttrs.find(
        customizableOption =>
            customizableOption?.option?.serviceId === ITEM_IS_CUSTOMIZABLE_ATTRIBUTE_ID
    );

    return {
        customizationOptions: regularCustomizable?.text,
        isResizable:
            attributes?.ringResizable?.[0]?.option?.serviceId ===
            ITEM_IS_RING_RESIZABLE_ATTRIBUTE_ID,
    };
};
